import * as THREE from 'three'

// 竖直直线与线段的交点
// 只包含起点，不包含终点，以避免重复
function segmentCut(a, b, x) {
    // 快速排除
    if ((a.x <= x && x < b.x) || (a.x >= x && x > b.x)) {
        let t = (x - a.x) / (b.x - a.x);
        let y = (1 - t) * a.y + t * b.y;
        return new THREE.Vector2(x, y);
    }
    return null;
}

function compare(a, b) {
    if (a < b) return 0;
    else if (a === b) return 1;
    else return 2; 
}

// 将一个凸多边形拆分为上下两个多边形链
function polyToPolyLines(poly) {
    let box = new THREE.Box2();
    let xIncrease = undefined;
    let polylines = [];
    let directions = [];
    let polyline = [];
    for (let i = 0, a = poly[poly.length - 1], b = poly[i]; i < poly.length; a = b, i++, b = poly[i]) {
        let xIncrease2 = compare(a.x, b.x);
        if (xIncrease === undefined) {
            if (xIncrease2 !== 1) {
                polyline = [a, b];
                xIncrease = xIncrease2;
            }
        } else {
            if (xIncrease2 === 1) {
                if (polyline.length >= 2) {
                    polylines.push(polyline);
                    directions.push(xIncrease);
                }
                polyline = [];
                xIncrease = undefined;
            } else if (xIncrease === xIncrease2) {
                polyline.push(b);
            } else {
                if (polyline.length >= 2) {
                    polylines.push(polyline);
                    directions.push(xIncrease);
                }
                polyline = [a, b];
                xIncrease = xIncrease2;
            }
        }
        box.expandByPoint(b);
    }
    if (polyline.length >= 2) {
        polylines.push(polyline);
        directions.push(xIncrease);
    }

    if (polylines.length === 2) {
        if (directions[0] === 0 && directions[1] === 2) {
            return {
                upChain: polylines[1],
                downChain: polylines[0],
                box, poly
            }
        } else if (directions[0] === 2 && directions[1] === 0) {
            return {
                upChain: polylines[0],
                downChain: polylines[1],
                box, poly
            }
        }
    } else if (polylines.length === 3) {
        if (directions[0] === 0 && directions[1] === 2 && directions[2] === 0) {
            return {
                upChain: polylines[1],
                downChain: [...polylines[2], ...polylines[0].slice(1)],
                box, poly
            }
        } else if (directions[0] === 2 && directions[1] === 0 && directions[2] === 2) {
            return {
                upChain: [...polylines[2], ...polylines[0].slice(1)],
                downChain: polylines[1],
                box, poly
            }
        }
    }

    // debugger
    // console.error("error convex polygon");
}

// 多边形链与竖直直线的交点
function polyChainCut(chain, x) {
    // debugger
    for (let i = 0; i < chain.length - 1; i++) {
        let inter = segmentCut(chain[i], chain[i + 1], x);
        if (inter) {
            return {
                index: i,
                point: inter
            }
        }
    }
    return null;
}

// 凸多边形被竖直直线对切割，保留中间部分
function convexPolygonCut(poly, x1, x2) {
    // debugger;
    let box = poly.box;
    // 快速排除
    if (box.max.x <= x1 || box.min.x >= x2) { return []; }

    // 内夹（包含在内部）
    if (x1 <= box.min.x && box.max.x <= x2) {
        return poly.poly;
        let rightMatch = poly.upChain[0].equals(poly.downChain[poly.downChain.length - 1]);
        let leftMatch = poly.downChain[0].equals(poly.upChain[poly.upChain.length - 1]);
        if (rightMatch && leftMatch) {
            return [
                ...poly.upChain.slice(1),
                ...poly.downChain.slice(1)
            ];
        } else if (rightMatch) {
            return [
                ...poly.upChain.slice(1),
                ...poly.downChain
            ];
        } else if (leftMatch) {
            return [
                ...poly.upChain,
                ...poly.downChain.slice(1)
            ];
        } else {
            return [
                ...poly.upChain,
                ...poly.downChain
            ];
        }
    }

    // x1 位于左侧，x2相交
    if (x1 <= box.min.x) {
        return poly.poly;
        let upInter = polyChainCut(poly.upChain, x2);
        let downInter = polyChainCut(poly.downChain, x2);

        if (upInter && downInter) {
            let points = [ ...poly.downChain.slice(0, downInter.index + 1), downInter.point, upInter.point, ...poly.upChain.slice(upInter.index + 1) ];
            if (points[0].equals(points[points.length - 1])) {
                points.splice(0, 1);
            }
            // console.log(points);
            return points;
        } else {
            console.error("error intersection count");
        }
    } else if (box.max.x <= x2) {
        return poly.poly;
        // return [];
        let upInter = polyChainCut(poly.upChain, x1);
        let downInter = polyChainCut(poly.downChain, x1);

        if (upInter && downInter) {
            let points = [ ...poly.upChain.slice(0, upInter.index + 1), upInter.point, downInter.point, ...poly.downChain.slice(downInter.index + 1) ];
            if (points[0].equals(points[points.length - 1])) {
                points.splice(0, 1);
            }
            console.log(points, THREE.ShapeUtils.isClockWise(points));
            return points;
        } else {
            debugger
            console.error("error intersection count");
        }
    }

    let upInter1 = polyChainCut(poly.upChain, x1);
    let downInter1 = polyChainCut(poly.downChain, x1);
    let upInter2 = polyChainCut(poly.upChain, x2);
    let downInter2 = polyChainCut(poly.downChain, x2);
    if (upInter1 && downInter1 && upInter2 && downInter2) {
        return [
            upInter2.point,
            ...poly.upChain.slice(upInter2.index + 1, upInter1.index + 1),
            upInter1.point,
            downInter1.point,
            ...poly.downChain.slice(downInter1.index + 1, downInter2.index + 1),
            downInter2.point
        ];
    }
    console.error("error intersection count");
}

export  {
    polyToPolyLines,
    convexPolygonCut
}



// WEBPACK FOOTER //
// ./src/views/makeTysonPenHolder/scripts/ConvexPolygonIntersect.js